let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6uIMF")).then(() => parcelRequire('3if1G'));